import {
  useViewsContext,
  useSearchContext,
  useGlobalizationContext,
  useCurrentUserContext,
  useGetAllFields,
  useGetView
} from '@cs-cms/state-management';
import { CpsFacetValue, CPS_FIELD_TYPE } from '@cs-cms/types';
import React from 'react';
import { GlobalFilter } from './GlobalFilter';
import { GroupedDateGlobalFilter } from './GroupedDateGlobalFilter';

interface GlobalFiltersProps {
  initialFacets?: Record<string, CpsFacetValue[]>;
}

export const GlobalFilters: React.FC<GlobalFiltersProps> = ({ initialFacets }) => {
  const { selectedView } = useViewsContext();
  const { data } = useSearchContext();
  const { selectedLocale } = useGlobalizationContext();
  const { selectedIndex } = useCurrentUserContext();
  const { data: fields } = useGetAllFields(selectedLocale, selectedIndex?.id);

  const { data: currentView } = useGetView(selectedView, selectedLocale);

  const getGlobalFieldDisplayName = (name: string): string => {
    const foundField = fields?.find(field => field.name === name);
    if (!foundField) {
      return name;
    }
    return foundField.displayName || foundField.name;
  };

  const facets = initialFacets || data?.facets;
  const visibleFieldNames = new Set((fields ?? []).filter(field => !field.technical).map(field => field.name));

  const globalFiltersWithMetadata =
    !currentView?.globalFilters || !fields
      ? []
      : currentView.globalFilters
          .filter(filter => visibleFieldNames.has(filter.name))
          .map(filter => ({
            ...filter,
            facetValues: facets?.[filter.name],
            displayName: getGlobalFieldDisplayName(filter.name)
          }));

  return (
    <div className="globalFilter">
      {globalFiltersWithMetadata
        ?.filter(filter => filter.type !== CPS_FIELD_TYPE.DATE && filter.type !== CPS_FIELD_TYPE.DATETIME)
        .map(filter => (
          <div key={filter.id} className={'filterItem'}>
            <GlobalFilter filterState={filter} />
          </div>
        ))}
      {globalFiltersWithMetadata?.some(
        filter => filter.type === CPS_FIELD_TYPE.DATE || filter.type === CPS_FIELD_TYPE.DATETIME
      ) && (
        <div key={'groupedDateGlobalFilter'} className={'filterItem'}>
          <GroupedDateGlobalFilter
            dateFiltersState={globalFiltersWithMetadata.filter(
              filter => filter.type === CPS_FIELD_TYPE.DATE || filter.type === CPS_FIELD_TYPE.DATETIME
            )}
          />
        </div>
      )}
    </div>
  );
};
